<template>
    <section class="app-main">
            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品名称：
                    </el-col>
                    <el-col :span="22">
                        <el-input v-model="title" placeholder="请输入商品名称" style="width:400px"></el-input>
                    </el-col>
                </el-row> 
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品主图：
                    </el-col>
                    <el-col :span="22">
                        <img-upload :img.sync="pic" :width="120" :height="120" file-name="purchase" ></img-upload>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        图片要求：
                    </el-col>
                    <el-col :span="22" class="input-left tips">
                        仅接受JPG、JPEG、PNG格式
                    </el-col>
                </el-row>
            </el-card>

            <el-card class="m-bottom-4" v-for="(it,i) in sku" :key="i">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品规格：
                    </el-col>
                    <el-col :span="22">
                        <el-select v-model="it.key" placeholder="选择规格" class="sku-input">
                            <i @click="handleRemoveKey(i,$event)" slot="prefix" class="el-input__icon el-icon-delete"></i>
                            <el-option v-for="item in specData" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                        <el-button plain class="sku-add" @click="handleSkuAdd()">添加规格</el-button>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        规格属性：
                    </el-col>
                    <el-col :span="22">
                        <el-input v-for="(item,index) in it.children" :key="index" v-model="item.value"  placeholder="输入属性名称" class="sku-input">
                            <i @click="handleRemoveValue(index,it.children)" slot="prefix" class="el-input__icon el-icon-delete"></i>
                        </el-input>
                        <el-button plain class="sku-add" @click="handleValueAdd(it.children)">添加属性</el-button>
                    </el-col>
                </el-row>
            </el-card>

            <el-card>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        提交商品：
                    </el-col>
                    <el-col :span="22">
                        <el-button  @click="handleSubmit()" type="success" plain style="width:150px">确认采购</el-button>
                    </el-col>
                </el-row>
            </el-card>
        
    </section>
</template>
<script>
import { specs_get, purchase } from '@/api/buy.js'
import ImgUpload from '@/components/m-upload.vue'
export default {
    name:'buyUpload',
    components:{ ImgUpload },
    data () {
        return {
            pic:{url: '', pic_id: ''},           // 主图id  
            clear:0,             // 清空 imgUpload 内容  0 不清空；1 提交成功之后清空； 2 未提交页面发生改变 需要删除当前上传的参数；            
            title:'',
            belongs:1,
            specData:[],   // 可选规格
            sku:[{key:'',children:[{value:''}]}],        // 商品规格
        }
    },
    methods:{
        
 

        // 获取规格
        handleSpec(){
            specs_get({language:'zh'}).then(res => {
                if(res){
                    this.specData = res.data
                }else{
                    this.specData = []
                }
               
            })
        },

        // 添加规格
        handleSkuAdd(){
            let obj = {
                key:'',
                children:[
                    {value:''}
                ]
            }
            this.sku.push(obj)
        },

        // 删除规格
        handleRemoveKey(i,e){
            e.stopPropagation()
            if(this.sku.length > 1){
                this.sku.splice(i,1)
            }
        },
        
        handleValueAdd(arr) {
            let obj = { value:'' }
            arr.push(obj)
        },
        // 删除规格的属性
        handleRemoveValue(index,arr){
            arr.splice(index,1)
        },


        // 重置图片上传组件的 clear
        handleClear(){
            this.clear = 0
        },

        handleSubmit(){
            if(this.title == ""){
                this.$message.error('请完善商品名称')
                return false
            }
            if(this.pic.pic_id == "{}"){
                this.$message.error('请完善商品介绍图片')
                return false
            }
            if(this.spec == "{}"){
                this.$message.error('请完善商品规格属性')
                return false
            }
            
            let params = {
                title:  this.title,
                belongs:this.belongs,
                pic:    this.pic.pic_id,
                specs:  this.spec,
            }
            console.log(params)
            purchase(params).then(res => {
                if(res){
                   this.$message({type:'success', message:res.msg, duration:1500})
                   this.clearData() 
                }
            })
        },

        clearData(){
            this.title   = ''
            this.belongs = 1
            this.pic     = ''
            this.sku     = [{key:'',children:[{value:''}]}]
            this.clear   = 1
        },
    },
    computed: {
        // 处理sku数组，返回后台需要的参数
        spec(){
            let obj = {}
            this.sku.forEach(e => {
                if(e.key != ""){
                    let arr =[]
                    e.children.forEach(el => {
                        if(el.value != ''){
                            arr.push(el.value)
                        }
                    })
                    obj[''+e.key] = arr
                }
            })
            return JSON.stringify(obj);
        }
    },
    created(){
        this.handleSpec()
    },
    activated() {
        this.handleSpec()
    },
    beforeRouteLeave(to,form,next){
        if(this.pic != ''){
            this.clear = 2
        }
        next()
    }
}
</script>
<style lang="less" scoped>
.sizing {
    box-sizing: border-box;
}
section {
    .input-left {
        height: 40px;
        line-height: 40px;
        min-width:80px ;
    }
    .tips {
        color: #909399;
        font-size: 14px;
    }
    
    .sku-value {
        height: 40px;
        line-height: 40px;
        margin:20px 15px 0 0;
    }
    .sku-input {
        width: 150px;
        margin-right: 20px;
    }
}
</style>

